import { K9SeatCfg } from "./k9_state_config";
import { K9 } from "../k9_data";
import Utility from "../../../../../utility/utility";
import GameUtil from "../../../../../utility/game_util";
import { HandCardEffect } from "../../../../jd/module/table/component/jd_handcard_effect";
import { K9DealCardsEffect } from "./k9_deal_cards_effect";
import { k9BetMoveEffect } from "./k9_bet_move_effect";
import { JdPokerComponent } from "../../../../jd/module/table/component/jd_poker_component";
import K9Help from "./k9_help";
import { K9HoldSprite } from "./k9_hold_sprite";
import K9Tian8 from "./k9_tian8";
import K9ShowPoker from "./k9_show_poker";
import JdSound from "../../../../jd/module/jd_sound";
import K9Sound from "./k9_sound";
import { Card } from "../../../../table/module/poker_table/poker_table_common";
import { PokerCommonColor } from "./poker_com_color";
import TablePlayerAvatar from "../../../../table/components/table_player_avatar";
import TablePokerBase from "../../../../table/module/table_base/table_poker_base";

const {ccclass, property} = cc._decorator;

@ccclass
export default class K9SeatView extends cc.Component {

    @property(cc.Label)
    mtest:cc.Label = null;

    @property(cc.Sprite)
    operatorTime:cc.Sprite = null;

    @property([cc.Node])
    showLayer:cc.Node[] = [];

    @property(cc.Node)
    cardsNode:cc.Node = null;

    @property([K9DealCardsEffect])
    SmallCards:K9DealCardsEffect[] = [];

    @property(HandCardEffect)
    handCardEffect:HandCardEffect = null;

    @property(cc.Label)
    cheknumb:cc.Label = null;

    @property(k9BetMoveEffect)
    betMoveEffect:k9BetMoveEffect = null;

    @property(cc.Node)
    betEndNode:cc.Node = null;

    @property(cc.Node)
    goldRoot:cc.Node = null;

    @property([PokerCommonColor])
    meHands:PokerCommonColor[] = [];

    @property(HandCardEffect)
    handEffect:HandCardEffect = null;

    @property([K9DealCardsEffect])
    bigCardsEffect:K9DealCardsEffect[] = [];

    loopCnt:cc.Label = null;

    syslab:cc.Node = null;
    
    @property(cc.Node)
    idelNode:cc.Node = null;

    @property(cc.Node)
    handNode:cc.Node = null;

    @property(cc.Node)
    timer:cc.Node = null;

    @property(cc.Label)
    operatorDes:cc.Label = null;

    @property([cc.Node])
    thinkNode:cc.Node[] = [];

    @property([cc.Label])
    scores:cc.Label[] = [];

    @property([cc.Node])
    normalpattern:cc.Node[]=[];

    @property([cc.Sprite])
    pattern:cc.Sprite[] = [];

    @property(K9HoldSprite)
    holdSprite:K9HoldSprite = null;

    @property(cc.Node)
    moveTo:cc.Node = null;

    @property(cc.SpriteFrame)
    sysImage:cc.SpriteFrame = null;

    @property([K9HoldSprite])
    rate_holdSprite:K9HoldSprite[] = [];

    @property(K9Tian8)
    k9tian8:K9Tian8 = null;

    @property(K9ShowPoker)
    k9ShowPoker:K9ShowPoker = null;

    @property(cc.Node)
    goldTarget:cc.Node = null;

    @property(cc.Sprite)
    teshuBeiShu:cc.Sprite = null;

    @property(cc.Node)
    effectNode:cc.Node = null;

    @property(cc.Node)
    emotionNode:cc.Node = null;

    @property(cc.Animation)
    scoreAnim:cc.Animation = null;

    @property(cc.Node)
    avatarNode:cc.Node = null;

    @property(cc.Node)
    pokerCtrl:cc.Node = null;

    //是否停止发牌
    isStopBigCard:boolean = false;

    //是否停止小牌
    isStopSmallCard:boolean = false;

    protected func:Function;

    onLoad(){
        this.resetUI();
        this.showLayer[0].on('click',this.showChat.bind(this))
    }

    isHavePlayer(isHave:boolean){
        this.showLayer[0].active = isHave;
        this.showLayer[2].active = !isHave
    }

    registerClickFunc(func:Function){
        this.func = func;
    }

    showChat(){
        if (this.func) {
            this.func();
        }
    }

    private isShowGold(isShow:boolean){
        this.goldRoot.active = isShow;
    }

    updateSeatInfo(cfg:K9SeatCfg){
        this.showLayer[1].position = cfg.mygold;
        this.cardsNode.position = cfg.small;
        //左右玩家
        this.goldTarget.position = cfg.goldDir ? cc.v3(-143.332,1.782):cc.v3(2.357,1.782);
        this.cheknumb.node.position = cfg.goldDir ? cc.v3(15.08,1):cc.v3(-6.438,1);
    }

    //更新玩家信息
    // updatePlayerInfo(data:K9.SeatData){
    //     this.tableSeatView.refreshCoinBalance(data.coin_balance);
    //     this.tableSeatView.refreshName(data.name);
    //     // this.setPlayerCoin(data.coin_balance);
    //     // this.setPlayerName(data.name);
    // }

    showPattern(isShow:boolean,data?:K9.SeatData){
        for (let pattern of this.normalpattern) {
            pattern.active = false;
        }
        this.hideAllRate();
        if (!isShow) {
            return;
        }
        if (data.card_type == 0) {//没有牌型
            return;
        }
        this.updateRate(data);
        //普通牌型
        if (data.card_type == K9.CardType.Single) {
            this.normalpattern[0].active = true;
            this.pattern[0].spriteFrame = this.holdSprite.getSpriteFrameByName(data.card_point.toString())
        }else if(this.isK8orK9(data)){

        }
        else{
            let anim = this.normalpattern[1].getComponent(cc.Animation);
            anim.play();
            this.normalpattern[1].active = true;
            this.pattern[1].spriteFrame= this.holdSprite.getSpriteFrameByName(K9.PokerDes[data.card_type]);
            this.pattern[2].spriteFrame= this.holdSprite.getSpriteFrameByName(K9.PokerDes[data.card_type]);
        }
    }

    //置灰牌型
    grayPattern(data:K9.SeatData){
        if (!data || data.state == K9.PlayerState.NoInGame) {
            return;
        }
        if (data.balance < 0) {
            if (this.isK8orK9(data)) {
                this.k9tian8.grayNode(true);
            }else{
                this.grayNode(data,true);
                this.k9ShowPoker.grayNode(data,true);
            }
        }
    }

    updatePoker(uid:number){
        let pokerBaseList = this.pokerCtrl.getComponentsInChildren(TablePokerBase);
        if (pokerBaseList) {
            pokerBaseList.forEach((pokerBase)=>{
                pokerBase.uid = uid;
                pokerBase.onUpdateBack();
            });
        }
    }

    protected grayNode(data:K9.SeatData,isGray:boolean){
        if (!isGray) {
            Utility.setNodeGray(this.normalpattern[0],false);
            Utility.setNodeGray(this.normalpattern[1],false);
            return;
        }
        if (!data || data.state == K9.PlayerState.NoInGame) {
            return;
        }
        if (data.card_type == K9.CardType.Single) {
            Utility.setNodeGray(this.normalpattern[0],true);
        }else{
            Utility.setNodeGray(this.normalpattern[1],true);
        }
    }

    //重置灰色
    resetGray(){
        this.k9tian8.grayNode(false);
        this.k9ShowPoker.grayNode(null,false);
        this.grayNode(null,false);
    }

    isK8orK9(data:K9.SeatData){
        if (!data) {
            return false
        }
        if(data.card_type == K9.CardType.K8
        || data.card_type == K9.CardType.K9)
        {
            return true;
        }
        return false;
    }

    setScore(isShow:boolean,score?:number,func?:Function){
        this.hideScores();
        let parent = this.scores[0].node.parent
        parent.stopAllActions();
        if (!isShow || score == 0) {
            return;
        }

        this.scoreAnim.play();

        let coin = GameUtil.currencyFormatting(score,2,true);
        let str = (score > 0 ? '+':'') + coin;
        
        let index = score < 0 ? 0 : 1;
        this.scores[index].node.active = true;
        this.scores[index].string = str;
 
        
        parent.position = cc.Vec3.ZERO;
        if (func) {
            func();
        }
    }

    hideScores(){
        for (const score of this.scores) {
            score.node.active = false;
        }
    }

    isShowMask(mask:boolean){
        //this.mask.active = mask;
    }

    getAction(tag:number){
        return this.node.getActionByTag(tag);
    }

    stopAction(tag:number){
        this.node.stopActionByTag(tag);
    }

    test(content:string){
        this.mtest.node.active = true;
        this.mtest.string = 'pos:' + content;
    }

    private totalTime:number = 0;
    private passTime:number = 0;
    private isStartTime:boolean = false;
    setOperatorTime(time:number,totalTime:number){
        let isShow = totalTime > 0;
        this.operatorTime.node.active = isShow;
        if (!isShow) {
            return
        }
        this.isStartTime = true;
        this.totalTime = totalTime;
        this.passTime = this.totalTime - time;
        this.operatorTime.fillStart = 0.25;
        this.operatorTime.fillCenter = cc.v2(0.5,0.5);
    }

    cancleOperator(){//
        this.isStartTime = false;
        this.operatorTime.node.active = false;
        this.isRole = false;
        this.setIdelState(1);
    }

    //0--点 2--圈
    setIdelState(state:number){
        this.idelNode.active = state == 0;
        this.operatorTime.node.active = state == 2;
    }

    isPlayClock(isPlay:boolean){
        this.isRole = isPlay;
    }

    isShowName(isShow:boolean){
        
    }

    isRole:boolean = false;
    clickTime:number = 0;
    update(delta:number){
        if (!this.isStartTime) {
            return;
        }
        if (this.isRole) {
            this.clickTime += delta;
            if (this.clickTime >= 1) {
                K9Sound.playClock();
                this.clickTime = 0;
            }   
        }
        this.passTime+=delta;
        let range = this.passTime / this.totalTime;
        this.operatorTime.fillRange = -range
        if (range >= 1) {
            this.isStartTime = false;
            this.operatorTime.node.active = false;
        }
    }

    resetSmallPoker(){
        for (let smallCard of this.SmallCards) {
            smallCard.reset();
        }
        this.isStopSmallCard = true;
    }

    //发牌
    dealCards(start:cc.Node,index:number,cards:number[]){
        if (this.isStopSmallCard) {
            return;
        }
        let smallCards = this.SmallCards;
        let smallCard = smallCards[index];
        if (!smallCard) {
            return;
        }

        let data = this.handCardEffect.getTransform(cards.length,index)
        if (data) {
            let pos = smallCard.node.parent.convertToNodeSpaceAR(data.worldPos);
            smallCards[index].dealCardsAction(start,()=>{
                
            },pos,data.angle);
    
            let nodes = [];
            for (let i = 0; i < smallCards.length; i++) {
                nodes.push(smallCards[i].node)
            }

            if (cards.length == 3) {
                this.handCardEffect.playerDealCardsAnim(cards.length,nodes);
            }
        }
    }

    //移动到banker
    moveToBank(pur:cc.Node,func:Function){
       this.node.stopActionByTag(K9.ActionTag.MoveBanker)
       let worldSpace = pur.convertToWorldSpaceAR(cc.Vec2.ZERO);
       let localPos = this.node.parent.convertToNodeSpaceAR(worldSpace);
       let move = cc.moveTo(0.2,localPos)
       let seq = cc.sequence(move,cc.callFunc(()=>{
           if (func) {
               func();
           }
       }))
       this.node.runAction(seq);
       seq.setTag(K9.ActionTag.MoveBanker);
    }

    tian8Show(data:K9.SeatData,isPlay:boolean = true){
        if (!data) {
            return;
        }        
        this.k9tian8.onShow(data,isPlay);
        this.k9ShowPoker.onReset();
        //普通牌型
        this.showPattern(false);
    }

    showPokers(data:K9.SeatData){
        if (!data) {
            return;
        }
        this.k9ShowPoker.onShow(data);
        this.k9tian8.onReset();
    }

    resetBigCards(){
        this.isStopBigCard = true;
        for (let hand of this.meHands) {
            hand.hide()
        }

        for (let effect of this.bigCardsEffect) {
            effect.reset()
        }
        
    }

    isBeginCard(isBegin:boolean){
        this.isStopSmallCard = false;
        this.isStopBigCard = false;
    }
    

    //发牌 大牌可直接显示
    dealBigCards(startNode:cc.Node,index:number,cards:number[],isPlayGame:boolean=true,comp?:Function){

        if (this.isStopBigCard) {
            return;
        }
        if (!cards) {
            cc.warn('没有牌')
            return;
        }
        let hand = this.meHands[index];
        hand.code = cards[index]
        hand.showBack();
        hand.show();
        let data = this.handEffect.getTransform(cards.length,index)
        if (!data) {
            cc.log('-->>',index,cards)
            return;
        }
        let pos = hand.node.parent.convertToNodeSpaceAR(data.worldPos);
        if (cards.length <= 2) {
            hand.node.zIndex = data.zIndex-10;
        }else{
            hand.node.zIndex = -6;
        }
        this.bigCardsEffect[index].dealMyCardsAction(startNode,pos,data.angle,()=>{
            if (index == 2) {//发第三张牌时
                let moveStep1 = ()=>{
                    this.dealOverCards(2,3,()=>{
                        //移动牌型
                        this.stopUserAction(K9.ActionTag.Three_FP)
                        let action = K9Help.delay(this.timer,()=>{
                            if (isPlayGame) {
                                if (comp) {
                                    comp();
                                }
                                let oldComp:PokerCommonColor[] = this.meHands.concat([]);
                                oldComp.sort((a:PokerCommonColor,b:PokerCommonColor)=>{
                                    let ma = Card.codeToIndex(a.code);
                                    let mb = Card.codeToIndex(b.code);
                                    return ma-mb
                                })
                                let isQKA = K9Help.isQKA(cards)
                                if (isQKA) {
                                    let temp = oldComp.shift();   
                                    oldComp.push(temp);
                                }

                                this.handEffect.playerDealCardsAnimEx(this.meHands,hand.node,oldComp,isQKA);   
                            }
                        },0.07)
                        action.setTag(K9.ActionTag.Three_FP);
    
                    },isPlayGame);
                }

                let nodes = [];
                for (let idx = 0; idx < this.meHands.length; idx++) {
                    nodes.push( this.meHands[idx].node)
                }
                this.handEffect.playerDealCardsAnim(3,nodes,moveStep1.bind(this)); 
            }
        });
    }

    //显示牌
    showSmallCards(cards:number[]){
        let smallCards = this.SmallCards;
        for (let idx = 0; idx <cards.length; idx++) {
            let hand = smallCards[idx];
            hand.resumeHands();
            let data = this.handCardEffect.getTransform(cards.length,idx)
            let pos = hand.node.parent.convertToNodeSpaceAR(data.worldPos);
            hand.node.position = pos;
            hand.node.scale = data.scale;
            hand.node.angle = data.angle;
        }
    }

    //显示手牌
    showBigCards(cards:number[]){
        for (let idx = 0; idx < cards.length; idx++) {
            let hand = this.meHands[idx];
            let effecthand = this.bigCardsEffect[idx];
            effecthand.resumeHands();
            let data = this.handEffect.getTransform(cards.length,idx)
            let pos = hand.node.parent.convertToNodeSpaceAR(data.worldPos);
            let node = hand.node;
            node.position = pos;
            node.scale = data.scale;
            node.angle = data.angle;
            node.zIndex = data.zIndex-10
            hand.code = cards[idx];
            hand.showPoker();
            hand.node.stopAllActions();
        }
    }

    updateBet(isShow:boolean,numb:number=0,isNeedAnim:boolean=true,func?:Function){
        if (numb <= 0 || !isShow) {
            this.isShowGold(isShow);
            return;
        }
        this.isShowGold(isShow);
        if (isNeedAnim) {
            this.betMoveEffect.checkBet(numb,null);
            //下注事件
            this.stopUserAction(K9.ActionTag.chekBet);
            let action = K9Help.delay(this.timer,()=>{
                if (func) {
                    func();
                }
            },0.3);
            action.setTag(K9.ActionTag.chekBet);
        }else{
            this.betMoveEffect.showBet(numb);
        }
        this.checkBet(numb)
    }

    stopUserAction(tag:number){
        this.timer.stopActionByTag(tag);
    } 

    private checkBet(num:number){
       let cheknum = GameUtil.currencyFormatting(num,2,true);
       this.cheknumb.string = cheknum;
    }

    //获得bet
    obtainBet(target:cc.Node,gold:number,comp:Function){
        this.betMoveEffect.obtainBet(target,this.betEndNode,gold,comp);
    }

    obtainBetEx(target:cc.Node,endNode:cc.Node,gold:number,comp:Function){
        this.betMoveEffect.obtainBet(target,endNode,gold,comp);
    }

    recycleAllBet(){
        this.betMoveEffect.recycleAllBet();
    }

    //发牌结束
    dealOverCards(start:number,endNumb:number,func?:Function,isPlayGame?:boolean){
        let sound = true;
        endNumb = endNumb <= this.meHands.length ? endNumb:this.meHands.length
        for (let i = start; i < endNumb; i++) {
            K9Help.rotateActionScaltoEx(this.meHands[i].node,0.1,0.2,()=>{
                this.meHands[i].showPoker();
                if (sound) {
                    JdSound.playRotatePoker();
                    sound = false;
                    if (func) {
                        func();
                    }
                }
            },null);
        }
    }

    dealyOver(start:number,endNumb:number,func?:Function,isPlayGame?:boolean){
        this.stopUserAction(K9.ActionTag.FP)
        let action = K9Help.delay(this.timer,()=>{
            this.dealOverCards(start,endNumb,func,isPlayGame);
        },0.4)
        action.setTag(K9.ActionTag.FP);
    }

    //归池
    guiChi(target:cc.Node,func?:Function){
        this.betMoveEffect.guiChi(target,func);
    }

    showOperator(isShow:boolean,content?:string,isNeed?:boolean){
        this.operatorDes.node.active = isShow;
        this.thinkNode[1].active = isNeed && isShow;
        this.thinkNode[0].active = !isNeed && isShow;
        if (!isShow) {
            return;
        }
        this.operatorDes.string = content;
        if (isNeed) {
            this.operatorDes.node.color = new cc.Color(142,255,255);
       
        }else{
            this.operatorDes.node.color = new cc.Color(168,49,43);
        }
    }

    hideAllRate(){
        for (let sp of this.rate_holdSprite) {
            sp.purpose.node.active = false;
        }
        this.teshuBeiShu.node.active = false;
    }

    //隐藏特殊牌型
    hidePeRate(){

    }

    showNormalRate(isShow:boolean,rate?:number,cards?:number[]){
        for (let sp of this.rate_holdSprite) {
            sp.purpose.node.active = false;
        }
        if (cards == undefined || !isShow) {
            return;
        }
        let cardSprite = this.rate_holdSprite[cards.length-2];
        cardSprite.purpose.node.active = true;
        cardSprite.setSprite(rate+'');
    }

    //更新倍率
    updateRate(data:K9.SeatData){
        if (!data) {
            return;
        }
        if (data.win_rate == 2
            || data.win_rate == 3
            || data.win_rate == 5) {
            if (data.card_type == K9.CardType.Single) {//普通牌型
                this.showNormalRate(true,data.win_rate,data.cards);
            }else if (this.isK8orK9(data)) {
                
            }else{//特殊牌型
                this.teshuBeiShu.node.active = true;
                this.teshuBeiShu.spriteFrame = this.holdSprite.getSpriteFrameByName('per_' + data.win_rate);
            }
        }
    }



    resetUI(){//重值UI
        this.hideScores();
        this.setIdelState(1);
        this.betMoveEffect.recycleAllBet();
        this.isShowGold(false);
        this.updateBet(false);
        this.resetSmallPoker();
        this.resetBigCards();
        this.showOperator(false);
        this.cancleOperator();
        this.setScore(false);
        this.timer.stopAllActions();
        this.showPattern(false);
        this.showNormalRate(false)
        this.k9tian8.onReset();
        this.k9ShowPoker.onReset();
        this.resetGray();
        this.hideAllRate();
    }
}
